/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface QuoteTestExecutionAudit
 */
export interface QuoteTestExecutionAudit {
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecutionAudit
   */
  subcommand?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecutionAudit
   */
  url?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecutionAudit
   */
  httpstatus?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecutionAudit
   */
  requestType?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecutionAudit
   */
  request?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecutionAudit
   */
  responseType?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExecutionAudit
   */
  response?: string;
}

/**
 * Check if a given object implements the QuoteTestExecutionAudit interface.
 */
export function instanceOfQuoteTestExecutionAudit(
  value: object,
): value is QuoteTestExecutionAudit {
  return true;
}

export function QuoteTestExecutionAuditFromJSON(
  json: any,
): QuoteTestExecutionAudit {
  return QuoteTestExecutionAuditFromJSONTyped(json, false);
}

export function QuoteTestExecutionAuditFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteTestExecutionAudit {
  if (json == null) {
    return json;
  }
  return {
    subcommand: json["subcommand"] == null ? undefined : json["subcommand"],
    url: json["url"] == null ? undefined : json["url"],
    httpstatus: json["httpstatus"] == null ? undefined : json["httpstatus"],
    requestType: json["requestType"] == null ? undefined : json["requestType"],
    request: json["request"] == null ? undefined : json["request"],
    responseType:
      json["responseType"] == null ? undefined : json["responseType"],
    response: json["response"] == null ? undefined : json["response"],
  };
}

export function QuoteTestExecutionAuditToJSON(
  json: any,
): QuoteTestExecutionAudit {
  return QuoteTestExecutionAuditToJSONTyped(json, false);
}

export function QuoteTestExecutionAuditToJSONTyped(
  value?: QuoteTestExecutionAudit | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    subcommand: value["subcommand"],
    url: value["url"],
    httpstatus: value["httpstatus"],
    requestType: value["requestType"],
    request: value["request"],
    responseType: value["responseType"],
    response: value["response"],
  };
}
